/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { Loader } from "@googlemaps/js-api-loader";

export default class ContactMap {
    constructor() {
        this.mapDiv = document.getElementById("map");
        this.gApiKey = __jsVarsContact.googleApiKey;

        if (this.mapDiv && this.gApiKey) {
            this.events();
        }
    }

    events() {
        this.initMap();
    }

    loaderInit() {
        this.loader = new Loader({
            apiKey: this.gApiKey,
        });
    }

    initMap() {
        this.loaderInit();

        this.loader.load().then(() => {
            const map = new google.maps.Map(this.mapDiv, {
                center: {
                    lat: Number(this.mapDiv.dataset.lat),
                    lng: Number(this.mapDiv.dataset.lng),
                },
                zoom: 15,
            });

            const marker = new google.maps.Marker({
                position: {
                    lat: Number(this.mapDiv.dataset.lat),
                    lng: Number(this.mapDiv.dataset.lng),
                },
                map,
            });
        });
    }
}
